var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((['male', 'female']),function(player){return _c('v-button',{key:player,attrs:{"icon":"arrow_up","label":"Kiezen"},on:{"click":function($event){return _vm.select(player)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }